// US routes (default app)
const routes = [
	{
		path: '/',
		name: 'Login',
		component: () => import('../components/LoginPage.vue'),
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import('../views/HomePage.vue'),
	},
	{
		path: '/ordinary-not-protected',
		name: 'OrdinaryNotProtected',
		component: () => import('../components/OrdinaryNotProtected.vue'),
	},
	{
		path: '/EmailRedirected',
		name: 'EmailRedirected',
		component: () => import('../components/FirebaseActionHandler.vue'),
	},
	{
		path: '/ordinary-protected',
		name: 'OrdinaryProtected',
		component: () => import('../components/OrdinaryProtected.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/account/:id',
		name: 'Account',
		component: () => import('../views/AccountCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/site/:id',
		name: 'Site',
		props: { isSite: true },
		component: () => import('../views/SiteCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/businessunit/:id',
		name: 'BusinessUnit',
		props: { isSite: false },
		component: () => import('../views/BusinessUnit.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/corporate/:id',
		name: 'Corporate',
		props: { isSite: false },
		component: () => import('../views/CorporateCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/organization',
		name: 'Organization',
		component: () => import('../views/OrganizationCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/export-requests',
		name: 'ExportRequests',
		component: () => import('../views/ExportRequests.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/create-user',
		name: 'CreateUser',
		component: () => import('../components/CreateUser.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
]

// CAN routes (addition)
const routesCAN = [
	{
		path: '/',
		name: 'LoginRoot',
		component: () => import('../components/LoginPage.vue'),
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import('../views/HomePage.vue'),
	},
	{
		path: '/login',
		meta: {
			title: 'Diversion Portal - Waste Connections Canada',
		},
		name: 'Login',
		component: () => import('../components/LoginPage.vue'),
	},
	{
		path: '/reset-password/:oobCode',
		meta: {
			title: 'Reset Password - Waste Connections Canada',
			mustBeLoggedIn: false,
		},
		name: 'ResetPassword',
		component: () => import('../components/ResetPassword.vue'),
	},
	{
		path: '/EmailRedirected',
		name: 'EmailRedirected',
		component: () => import('../components/FirebaseActionHandler.vue'),
	},
	{
		path: '/account/:id/:mode/:national',
		name: 'Account',
		component: () => import('../views/AccountCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/District/:id',
		name: 'District',
		props: { theType: 'District' },
		component: () => import('../views/Canada/DistrictView.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/Province/:id',
		name: 'Province',
		props: { theType: 'Province' },
		component: () => import('../views/Canada/ProvinceView.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/NationalAccount/:id',
		name: 'NationalAccount',
		props: { theType: 'NationalAccount' },
		component: () => import('../views/Canada/NationalAccount.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	// {
	// 	path: '/organization/:id?',
	// 	name: 'Organization',
	// 	component: () => import('../views/OrganizationCmp.vue'),
	// 	meta: {
	// 		mustBeLoggedIn: true,
	// 	},
	// },
	{
		path: '/search',
		name: 'Search',
		component: () => import('../views/OrganizationCmp.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/create-user',
		name: 'CreateUser',
		component: () => import('../components/CreateUser.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/update-user/:success/:error',
		name: 'UpdateUser',
		component: () => import('../components/UpdateUser.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/copy-transfer-user/:mode/:success/:error',
		name: 'CopyTransferUser',
		component: () => import('../components/CopyTransferUser.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/DeleteUser/:success/:error',
		name: 'DeleteUser',
		component: () => import('../components/DeleteUser.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/MaterialReportPDF',
		name: 'MaterialReportPDF',
		component: () => import('../views/MaterialReportPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/DiversionReportPDF',
		name: 'DiversionReportPDF',
		component: () => import('../views/DiversionReportPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/DiversionByMonthPDF',
		name: 'DiversionByMonthPDF',
		component: () => import('../views/DiversionByMonthPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/EnvironmentalPDF',
		name: 'EnvironmentalPDF',
		component: () => import('../views/EnvironmentalPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/MaterialCompositionPDF',
		name: 'MaterialCompositionPDF',
		component: () => import('../views/MaterialCompositionPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/CompletedCallsPDF',
		name: 'CompletedCallsPDF',
		component: () => import('../views/CompletedCallsPDF.vue'),
		meta: {
			mustBeLoggedIn: false,
		},
	},
	{
		path: '/manage-customer-groups',
		name: 'ManageCustomerGroups',
		component: () => import('../components/ManageCustomerGroups.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/manage-customer-group/:id',
		name: 'ManageCustomerGroup',
		component: () => import('../components/ManageCustomerGroup.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/manage-customer-group-users/:id',
		name: 'ManageCustomerGroupUsers',
		component: () => import('../components/ManageCustomerGroupUsers.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/manage-users-access',
		name: 'ManageUsersAccess',
		component: () => import('../components/ManageUsersAccess.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
	{
		path: '/manage-user-access/:id',
		name: 'ManageUserAccess',
		component: () => import('../components/ManageUserAccess.vue'),
		meta: {
			mustBeLoggedIn: true,
		},
	},
]

export { routes, routesCAN }
